function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextilesLeatherAndPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13,227.55a4,4,0,0,1-1.53-.3,4,4,0,0,1-2.43-3.14c-2.07-14.74-12.9-30.29-27.44-30.79a8.32,8.32,0,0,1-5.87-2.73,8,8,0,0,1-2-6l.79-9.91a8.19,8.19,0,0,1,3.14-5.79,7.93,7.93,0,0,1,6.24-1.53c7.57,1.35,14.91-3.11,18.22-11.11a17.69,17.69,0,0,0-6.3-21.27,7.93,7.93,0,0,1-3.37-5.5,8.17,8.17,0,0,1,1.87-6.35l7.62-8.94a8.09,8.09,0,0,1,8.64-2.44,28.06,28.06,0,0,0,33.07-13.17,8,8,0,0,1,10.13-3.52l21.24,8.8a8,8,0,0,1,4.68,9.66,28.06,28.06,0,0,0,14.07,32.69,8.06,8.06,0,0,1,4.38,7.84l-.93,11.71a8.16,8.16,0,0,1-3.16,5.81,8,8,0,0,1-6.27,1.5,17.71,17.71,0,0,0-19.5,10.59c-3.32,8-1.3,16.34,5,20.74a7.94,7.94,0,0,1,3.32,5.49,8.16,8.16,0,0,1-1.87,6.32l-6.44,7.56a8,8,0,0,1-5.66,2.81,8.35,8.35,0,0,1-6.09-2.22c-10.63-9.92-29.28-6.58-41.16,2.38A4,4,0,0,1,132.13,227.55Zm26-17.25c9.34,0,17.61,3.18,23,8.23l6.64-7.5c-9.42-6.66-12.57-18.86-7.78-30.43a25.72,25.72,0,0,1,28.36-15.38l.92-11.8a36.19,36.19,0,0,1-18.16-42.12l-21.3-8.84a36.21,36.21,0,0,1-42.57,16.93l-7.74,8.94a25.9,25.9,0,0,1,9.11,31c-4.8,11.57-15.66,18-27,15.92l-.79,10c13.4.53,28.89,11.68,34.06,31.66A45.89,45.89,0,0,1,158.15,210.3Z",
    style: {
      fill: "#d07f2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.17,264.83a4,4,0,0,1-3.7-2.47L200,249l-13.32,5.52a4,4,0,0,1-5.23-2.16l-5.52-13.33-13.33,5.52a4,4,0,0,1-3.06,0,4,4,0,0,1-2.17-2.17l-4-9.74a4,4,0,1,1,7.39-3.06l2.5,6,13.33-5.53a4,4,0,0,1,5.23,2.17l5.52,13.33,13.33-5.52a4,4,0,0,1,5.23,2.16l5.52,13.33,9.63-4-5.52-13.33a4,4,0,0,1,2.16-5.22l13.33-5.52-5.52-13.33a4,4,0,0,1,2.17-5.23l13.33-5.52-5.53-13.33a4,4,0,0,1,2.17-5.23l13.33-5.52-5.52-13.33a4,4,0,0,1,2.16-5.22l13.33-5.52-4-9.64-13.33,5.52a4,4,0,0,1-5.23-2.16l-5.52-13.33-13.32,5.52a4,4,0,0,1-5.23-2.16l-7.05-17a4,4,0,1,1,7.39-3.06l5.52,13.33,13.33-5.52a4,4,0,0,1,5.23,2.16l5.52,13.33,13.33-5.52a4,4,0,0,1,5.22,2.16l7,17a4,4,0,0,1-2.16,5.23l-13.33,5.52L259.81,180a4,4,0,0,1-2.16,5.22l-13.33,5.52,5.52,13.33a4.08,4.08,0,0,1,0,3.07,4,4,0,0,1-2.17,2.16l-13.33,5.52,5.53,13.33a4,4,0,0,1-2.17,5.23l-13.33,5.52,5.52,13.33a4,4,0,0,1-2.16,5.22l-17,7.06A4.12,4.12,0,0,1,209.17,264.83Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.76,289.55a4.07,4.07,0,0,1-1.52-.3l-75.78-31.17a4,4,0,1,1,3-7.39l72.09,29.64,43.34-104.62-11.54-4.61a4,4,0,1,1,3-7.43l15.3,6.11a4,4,0,0,1,2.21,5.25l-46.41,112A4,4,0,0,1,240.76,289.55Z",
    style: {
      fill: "#ced2d6"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextilesLeatherAndPaper);
export default __webpack_public_path__ + "static/media/textiles-leather-and-paper.532501b51590c51c72bdf59e7f13b54d.svg";
export { ForwardRef as ReactComponent };